import * as React from 'react';
import { TravellerFieldEnum } from '@websky/graphql';
import Money from '../../../../../../Money';
import { Button } from '../../../../../../index';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../theme';
import cn from 'classnames';
import { Tooltip } from '../../../../../../BaseComponents';
const EveryPortTraveller = ({ traveller, price, isSelected, onClick, tooltipText, disabled, isConfirmed }) => {
    var _a, _b;
    const firstName = ((_a = traveller.values.find(value => value.type === TravellerFieldEnum.FirstName)) === null || _a === void 0 ? void 0 : _a.value) || '', lastName = ((_b = traveller.values.find(value => value.type === TravellerFieldEnum.LastName)) === null || _b === void 0 ? void 0 : _b.value) || '';
    const { t } = useTranslation('ServiceAggregation');
    const theme = useTheme('CheckoutAdditionalService').EveryPortLounge;
    return (React.createElement("div", { className: theme.traveller },
        React.createElement("div", { className: theme.traveller__name }, firstName === null || firstName === void 0 ? void 0 :
            firstName.toLowerCase(),
            " ", lastName === null || lastName === void 0 ? void 0 :
            lastName.toLowerCase()),
        React.createElement("div", { className: theme.traveller__controls },
            React.createElement(Money, { money: price }),
            !isConfirmed && (React.createElement(Tooltip, { open: !!tooltipText, title: tooltipText },
                React.createElement("div", null,
                    React.createElement(Button, { onClick: onClick, className: cn(theme.button_passenger, theme.button, {
                            [theme.button_selected]: isSelected,
                            [theme.button_disabled]: disabled
                        }), disabled: disabled }, t(isSelected ? 'Cancel' : 'Select'))))))));
};
export default EveryPortTraveller;
